import request from '@/utils/request'

// 查询用户列表
export function userList(query) {
	return request({
		url: '/biz/member/pageList',
		method: 'get',
		params: query
	})
}

// 编辑用户
export function editUser(data) {
	return request({
		url: '/biz/member/edit',
		method: 'post',
		data: data
	})
}

// 删除用户
export function delUser(ids) {
	return request({
		url: `/biz/member/${ids}`,
		method: 'get'
	})
}

// 查询用户个人信息
export function userInfo(data) {
	return request({
		url: `/biz/member/getInfo`,
		method: 'get',
		params: data
	})
}
// 登录日志
export function loginLog(query) {
	return request({
		url: '/biz/loginTrace/list',
		method: 'get',
		params: query
	})
}
// 查询拉新列表
export function inviteList(query) {
	return request({
		url: '/biz/inviteNew/list',
		method: 'get',
		params: query
	})
}
// 查询拉新列表
export function inviteProfit(query) {
	return request({
		url: '/biz/merchant/profitListVo',
		method: 'get',
		params: query
	})
}

// 查询商户列表
export function merchantList(query) {
	return request({
		url: '/biz/merchant/list',
		method: 'get',
		params: query
	})
}
// 查询用商户信息
export function merchantInfo(query) {
	return request({
		url: `/biz/merchant/getDetail`,
		method: 'get',
		params: query
	})
}
// 审核商户
export function merchantAudit(data) {
	return request({
		url: '/biz/merchant/audit',
		method: 'post',
		data: data
	})
}
// 查询商户类型列表
export function typeList(query) {
	return request({
		url: '/biz/merchantType/pageList',
		method: 'get',
		params: query
	})
}
// 新增商户品类
export function addType(data) {
	return request({
		url: '/biz/merchantType',
		method: 'post',
		data: data
	})
}
// 编辑商户品类
export function editType(data) {
	return request({
		url: '/biz/merchantType',
		method: 'post',
		data: data
	})
}
// 商户品类启用
export function switchType(data) {
	return request({
		url: `/biz/merchantType/updateIsEnable`,
		method: 'post',
		params: data
	})
}
// 商户品类更新排序
export function typeSort(params) {
	return request({
		url: '/biz/merchantType/updateSort',
		method: 'post',
		data: params
	})
}
// 删除商户品类
export function delType(ids) {
	return request({
		url: `/biz/merchantType/${ids}`,
		method: 'get'
	})
}

// 查询商户管理员列表
export function getManagers(query) {
	return request({
		url: '/biz/member/listShopAdmin',
		method: 'get',
		params: query
	})
}
// 查询任务(活动)列表
export function getTaskList(query) {
	return request({
		url: '/biz/act/list',
		method: 'get',
		params: query
	})
}
// 编辑活动
export function editTask(params) {
	return request({
		url: '/biz/act',
		method: 'post',
		data: params
	})
}
// 审核活动
export function AuditTask(params) {
	return request({
		url: '/biz/act/audit',
		method: 'post',
		data: params
	})
}

// *************************个人赛事详情（参与-举办
// 查询赛事列表(举办
export function matchList(query) {
	return request({
		url: '/biz/match/list',
		method: 'get',
		params: query
	})
}

//加入的赛事 （参与
export function applyList(query) {
	return request({
		url: '/biz/match/pageApplyList',
		method: 'get',
		params: query
	})
}